import { Input } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MenuUserSearch = () => {
  const [showInput, setShowInput] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const handleSearch = (value) => {
    const trimmedValue = value.trim();
    navigate(trimmedValue ? `/dich-vu?search=${encodeURIComponent(trimmedValue)}` : "/dich-vu");
    setSearchValue("");
    setShowInput(false);
  };

  const toggleSearch = () => {
    setShowInput(prev => !prev);
    if (showInput) {
      setSearchValue("");
    }
  };

  return (
    <div className="the-header-search">
      <div className="_search">
        <div className={`search-input-container ${showInput ? "show" : ""}`}>
          <Input 
            placeholder="Tìm kiếm..." 
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onPressEnter={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div
          className={`_btn-search ${showInput ? "show" : ""}`}
          onClick={toggleSearch}
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9375 13.25H14.0487L13.7337 12.9462C14.8362 11.6637 15.5 9.99875 15.5 8.1875C15.5 4.14875 12.2262 0.875 8.1875 0.875C4.14875 0.875 0.875 4.14875 0.875 8.1875C0.875 12.2262 4.14875 15.5 8.1875 15.5C9.99875 15.5 11.6637 14.8362 12.9462 13.7337L13.25 14.0487V14.9375L18.875 20.5512L20.5512 18.875L14.9375 13.25ZM8.1875 13.25C5.38625 13.25 3.125 10.9887 3.125 8.1875C3.125 5.38625 5.38625 3.125 8.1875 3.125C10.9887 3.125 13.25 5.38625 13.25 8.1875C13.25 10.9887 10.9887 13.25 8.1875 13.25Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div className="logo-number">{"0945 477 279"}</div>
    </div>
  );
};

export default MenuUserSearch;
